var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-avatar d-flex align-items-center",style:([_vm.colorStyle, _vm.shadow ? _vm.shadowStyle : '', _vm.avatarSize])},[(!_vm.avatar)?_c('span',{staticClass:"mx-auto"},[_vm._v(" "+_vm._s(_vm.initial)+" ")]):_c('img',{staticClass:"md-avatar-img mx-auto",attrs:{"src":_vm.avatar,"alt":"User Avatar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }